import { Alert, TextField, Typography } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import * as yup from 'yup'
import { ResourcesTable } from './ResourcesTable';


export const LessonResourcesDownloadHandler = (props: LessonResourcesDownloadHandlerProps) => {

    const [description, setDescription] = useState<string>(props.data.description || '');
    const [resources, setResources] = useState<IResourceItem[]>(props.data.data || []);

    useEffect(() => {
        props.onChange({
            data: {
                data: resources,
                description: description
            }
        })
    }, [resources, description]);
    return (
        <div className='space-y-6'>
            <Alert severity="info">
                Para visualizar los cambios debes hacer clic en el botón <i>Publicar</i>
            </Alert>
            <div className='space-y-2'>
                <Typography variant="h6">
                    Descripción
                </Typography>
                <Typography variant="subtitle1">
                    Ingresa la descripción del ejercicio
                </Typography>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Descripción"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </div>
            <div className='space-y-2'>
                <Typography variant="h6">
                    Documentos
                </Typography>
                <Typography variant="subtitle1">
                    Ingresa los documentos del ejercicio
                </Typography>
                <ResourcesTable data={resources} onChange={setResources} />
            </div>
        </div>
    );
}